var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isVisibleComponent
    ? _c(
        "div",
        { attrs: { "data-qa": "award-winner" } },
        [
          _c(
            "div",
            {
              staticClass:
                "d-inline-flex align-center py-1 px-2 rounded bg-warning cursor-pointer",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _setup.isActive = !_setup.isActive
                },
              },
            },
            [
              _c("div", { staticClass: "ui-icon-rating-40 rating--text" }),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-2 text--text ml-2" }, [
                _vm._v("\n      " + _vm._s(_setup.title) + "\n    "),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(_setup.AwardDialog, {
            attrs: {
              type: _vm.type,
              title: _setup.title,
              "is-active": _setup.isActive,
              "current-award-year": _vm.currentAwardYear,
            },
            on: { input: _setup.handleInput, redirect: _setup.handleRedirect },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }